import styled from "styled-components";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

const Switcher = styled.div`
  display: flex;
  gap: 0.35rem;
`;
const Button = styled.button<{ $active: boolean }>`
  border: 1px solid ${({ $active }) => ($active ? "#d4af37" : "rgba(212,175,55,.45)")};
  border-radius: 0.3rem;
  background: ${({ $active }) => ($active ? "rgba(212,175,55,.18)" : "transparent")};
  color: #d4af37;
  cursor: pointer;
  font: 600 0.72rem/1 "Segoe UI", sans-serif;
  letter-spacing: .04em;
  padding: .35rem .42rem;
  &:hover { background: rgba(212,175,55,.18); }
`;

const LanguageSwitcher = () => {
  const { t } = useTranslation();
  const language = i18n.language;
  const changeLanguage = (lng: "nl" | "en" | "ar") => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
    document.documentElement.lang = lng;
  };
  return <Switcher aria-label={t("nav.language")}>
    {(["ar", "en", "nl"] as const).map((lng) => <Button key={lng} $active={language === lng} onClick={() => changeLanguage(lng)}>{lng.toUpperCase()}</Button>)}
  </Switcher>;
};
export default LanguageSwitcher;
